import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative py-8 md:py-20 px-4 overflow-hidden" data-id="element-171">
      <div className="absolute inset-0 bg-gradient-radial from-gold/5 to-transparent opacity-30 pointer-events-none" data-id="element-172" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-173">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-navy-dark mb-6 md:mb-10 leading-tight" data-id="element-174">
          Tu vocación ya la tenés.{' '}
          <span className="block md:inline" data-id="element-175">
            Las herramientas te las damos nosotros.
          </span>{' '}
          <span className="text-gold italic block md:inline mt-2 md:mt-0" data-id="element-176">
            Más Allá de la Voluntad
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-[245px] md:max-w-[350px] mx-auto mb-6 md:mb-10" data-id="element-177">
          <div className="absolute inset-0 bg-gradient-radial from-gold/20 to-transparent blur-3xl" data-id="element-178" />
          <motion.img src="https://cdn.magicpatterns.com/uploads/gpC7kqG9nsKx2WK5m7c3Ce/Gemini_Generated_Image_vkxdf1vkxdf1vkxd__1_-removebg-preview.png" alt="Más Allá de la Voluntad - Sistema completo" width={700} height={700} loading="eager" decoding="async"
        // @ts-ignore
        fetchpriority="high" className="relative w-full h-auto drop-shadow-2xl" animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-179" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-base md:text-xl text-gray-700 mb-6 md:mb-8 leading-relaxed max-w-3xl mx-auto font-[500]" data-id="element-180">
          El sistema completo para orientadores en adicciones conductuales en
          Argentina. Protocolos, fichas y herramientas listas para usar en tu
          próximo encuentro.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-8 text-xs md:text-sm" data-id="element-181">
          <span className="bg-navy-dark text-cream-bg px-3 py-1 md:px-4 md:py-1.5 rounded-full font-semibold" data-id="element-182">
            📚 6 + 6 Volúmenes + Bonos
          </span>
          <span className="bg-white px-2.5 py-1 md:px-3 md:py-1.5 rounded-full shadow-sm" data-id="element-183">
            📄 PDF Digital
          </span>
          <span className="bg-white px-2.5 py-1 md:px-3 md:py-1.5 rounded-full shadow-sm" data-id="element-184">
            ⚡ Acceso Inmediato
          </span>
          <span className="bg-white px-2.5 py-1 md:px-3 md:py-1.5 rounded-full shadow-sm" data-id="element-185">
            🎯 Profesionales de la Salud
          </span>
          <span className="bg-white px-2.5 py-1 md:px-3 md:py-1.5 rounded-full shadow-sm" data-id="element-186">
            🇦🇷 Todo Argentina
          </span>
        </motion.div>

        <motion.a href="#ofertas" animate={{
        scale: [1, 1.03, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="inline-block w-full md:w-auto text-center bg-gold hover:bg-gold-bright text-navy-dark font-bold text-base md:text-lg px-6 md:px-10 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 mb-5 md:mb-6" data-id="element-187">
          💥 QUIERO MI ACOMPAÑAMIENTO RESUELTO AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 text-[10px] md:text-sm text-gray-600" data-id="element-188">
          <span data-id="element-189">✅ Garantía 7 días</span>
          <span data-id="element-190">🔒 Pago seguro</span>
          <span data-id="element-191">💳 Mercado Pago</span>
          <span data-id="element-192">👥 +300 Profesionales</span>
          <span data-id="element-193">⭐ 4.9 Rating</span>
          <span data-id="element-194">🗺️ Todo Argentina</span>
        </div>
      </div>
    </section>;
}